import React from 'react'
import { Checkbox } from 'src/components/Checkbox'
import { SelectFilters } from 'src/components/SelectFilters'

export const MarketsFilters = ({
  filters,
  onlyVerifiedIsAvailable,
  onlyVerified,
  changeOnlyVerified,
}) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {filters.map(filter => (
      <SelectFilters
        withInternalScroll
        withSearch={filter.name === 'pair' || filter.name === 'currency'}
        key={filter.name}
        labelInside={`${filter.labelInside}: `}
        selectList={filter.options}
        targetValue={filter.value}
        onChangeAction={filter.onChangeHandler}
        className='MarketsFilter'
      />
    ))}

    {onlyVerifiedIsAvailable && (
      <Checkbox
        className='MarketsFilter'
        checked={onlyVerified}
        label='Only verified'
        onChange={changeOnlyVerified}
      />
    )}
  </div>
)
